import { useClerk } from '@clerk/nextjs';
import { SessionResource } from '@clerk/types';
import handleSetActive from 'utils/handleSetActive';

interface UseActivateSessionParams {
  session?: string | SessionResource;
  redirectTo?: string;
  onAfterSuccess?: () => void;
  shouldRedirect?: boolean;
}

export default function useActivateSession() {
  const { session: clerkSession, setActive } = useClerk();

  return async ({ session, redirectTo, onAfterSuccess, shouldRedirect }: UseActivateSessionParams): Promise<void> => {
    const effectiveSession = session ?? clerkSession;

    if (effectiveSession === undefined) {
      console.warn('Clerk session is still loading, cannot activate session yet.');
      return undefined;
    }

    const sessionId = typeof effectiveSession === 'string' ? effectiveSession : effectiveSession?.id;

    if (!sessionId) {
      console.warn('Session id not present in session input or Clerk session');
      return undefined;
    }

    return handleSetActive({
      sessionId,
      redirectTo: redirectTo || '/',
      setActive,
      onAfterSuccess,
      shouldRedirect,
    });
  };
}
